
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/widgets/[widgetUuid]",
      function () {
        return require("private-next-pages/app/widgets/[widgetUuid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/widgets/[widgetUuid]"])
      });
    }
  